import { render, staticRenderFns } from "./EditPinTuanGoods.vue?vue&type=template&id=f95f4e76&"
import script from "./EditPinTuanGoods.vue?vue&type=script&lang=js&"
export * from "./EditPinTuanGoods.vue?vue&type=script&lang=js&"
import style0 from "./EditPinTuanGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports